import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCoffee } from "@fortawesome/free-solid-svg-icons";

const MetricWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 10px;
  width: 20%;
  @media (max-width: ${({ theme }) => theme.breakpoints.phone}) {
    width: 100%;
  }
`;

const IconWrapper = styled.div`
  color: var(--color-primary);
  background-color: var(--color-secondary);
  width: 60px;
  height: 60px;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const Number = styled.p`
  color: var(--color-body-text);
  margin: 0.8rem 0.8rem 0.2rem 0.8rem;
  line-height: 1;
  font-weight: 800;
  font-size: 1.8rem;
  font-family: var(--font-paragraphs);
  transform: translateY(20px);
  transition: all 1s linear;
  opacity: 0;
  text-align: center;
  min-width: 170px;
  &.visible {
    transform: translateY(0px);
    opacity: 1;
  }
`;

const Text = styled.p`
  color: var(--color-primary);
  font-family: var(--font-paragraphs);
  font-size: 0.9rem;
  margin: 0;
  font-weight: 600;
  text-align: center;
  max-width: 155px;
`;

export default function Metric({ icon, number, text, unit }) {
  const ref = React.useRef();
  const [counter, setCounter] = React.useState(0);
  const [frame, setFrame] = React.useState(0);

  const [isVisible, setVisible] = React.useState(false);

  React.useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting) {
          setVisible(true);
        }
      },
      { rootMargin: "0px 0px 0px 0px" }
    );
    ref && observer.observe(ref.current);
  }, []);

  React.useEffect(() => {
    if (isVisible) {
      const counter = setInterval(() => {
        if (isVisible && frame <= 20) {
          setCounter(Math.round(parseInt(number) * (frame / 20)));
          setFrame(frame + 1);
        }
        clearInterval(counter);
      }, 50);
    }
  }, [frame, isVisible]);

  return (
    <MetricWrapper ref={ref}>
      <IconWrapper>
        <FontAwesomeIcon icon={icon} size="2x" />
      </IconWrapper>
      <Number className={frame > 1 ? "visible" : ""}>
        {counter.toLocaleString()}
        {unit}
      </Number>
      <Text>{text}</Text>
    </MetricWrapper>
  );
}

Metric.propTypes = {
  icon: PropTypes.object,
  number: PropTypes.string,
  text: PropTypes.string,
  unit: PropTypes.string,
};

Metric.defaultProps = {
  icon: faCoffee,
  number: "",
  text: "",
  unit: "",
};
